import {ImageField, RichTextField, SelectField} from '@prismicio/client'
import dynamic from 'next/dynamic'
import {
  CustomerStoryContentSliceV2PrimaryAddOnsItem,
  CustomerStoryContentSliceV2PrimaryCtaItem,
  CustomerStoryContentSliceV2PrimaryProductsUsedItem,
} from 'prismicio-types'
import {SummarySection} from './SummarySection'
import {CTASection} from './CTASection'

const SidebarWrapper = dynamic(() => import('./SidebarWrapper').then((mod) => mod.SidebarWrapper), {ssr: false})

export const Sidebar = ({
  companyLogo,
  summary,
  cta,
  products,
  addons,
  category,
  location,
  headcount,
}: {
  companyLogo: ImageField
  summary: RichTextField
  cta?: CustomerStoryContentSliceV2PrimaryCtaItem
  products?: CustomerStoryContentSliceV2PrimaryProductsUsedItem[]
  addons?: CustomerStoryContentSliceV2PrimaryAddOnsItem[]
  category: SelectField<'Ecommerce' | 'Professional Services' | 'Hospitality' | 'Technology'>
  location: string
  headcount: string
}) => {
  return (
    <SidebarWrapper>
      <SummarySection
        companyLogo={companyLogo}
        summary={summary}
        products={products}
        addons={addons}
        category={category}
        location={location}
        headcount={headcount}
      />
      {cta && <CTASection cta={cta} />}
    </SidebarWrapper>
  )
}
